class PickupAddressController {
    constructor($element, settings, pickupAddressSearchService, featureService, moveFocus) {
        this.$element = $element;
        this.pickupAddressSearch = pickupAddressSearchService;
        this.settings = settings;
        this.moveFocus = moveFocus;

        this.isStoreSearchEnabled = featureService.isEnabled(featureService.features.clickAndCollectStoreSearch);
        this.id = $element.attr('id') || '';
    }

    $onInit() {
        this.pickupStores = [];

        this.storesPerPage = this.settings.clickAndCollect.clickAndCollectStoresPerPage;
        this.numberOfStoresToShow = this.storesPerPage;
    }

    setStores(stores) {
        this.pickupStores = stores;
        this.selectedStore = null;
    }

    hasStores() {
        return !!this.pickupStores && this.pickupStores.length > 0;
    }

    hasMoreStores() {
        return this.hasStores() && this.numberOfStoresToShow < this.pickupStores.length;
    }

    viewMoreStores() {
        const numberPreviouslyShowing = this.numberOfStoresToShow;

        if (this.hasMoreStores()) {
            this.numberOfStoresToShow += this.storesPerPage;
        }

        this.moveFocus(() => this.$element.find('._pickupAddressSearch-searchResult').eq(numberPreviouslyShowing));
    }

    onSelectStore(store) {
        this.selectedStore = store.AddressId;
        this.setPickupAddress({ addr: store });
    }
}

const pickupAddressComponentDefinition = {
    bindings: {
        setPickupAddress: '&',
        classModifier: '@?',
        isRequired: '<?',
    },
    controller: ['$element', 'Settings', 'PickupAddressSearchService', 'FeatureService', 'MoveFocus', PickupAddressController],
    template: require('./pickup-address.component.html').trim(),
};

module.exports = {
    PickupAddressController,
    pickupAddressComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/fulfilment/address/pickup-address.component.js